export const questionAnswerQueryKeys = {
  all: ["title", "answer"],
  byId: (id: number | undefined) => [...questionAnswerQueryKeys.all, id],
};
